module.exports = __webpack_public_path__ + "img/1.216434a8.jpg";